// Copied from platform-app components/pos/receipt/AddBlockMenu.tsx on 2026-10-14 for Super Admin → POS Defaults — keep in step with the original.
import React, { useState } from 'react';
import { BLOCK_TYPES, BLOCK_LABELS, makeBlock, type BlockType } from './blockDefaults';
import type { ReceiptBlock } from '@platform/shared-types';

export default function AddBlockMenu({ onAdd, disabled }: { onAdd: (b: ReceiptBlock) => void; disabled?: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative inline-block">
      <button
        type="button"
        className="text-xs text-accent-700 font-semibold disabled:text-stone-300"
        onClick={() => setOpen((v) => !v)}
        disabled={disabled}
      >
        + Add Block ▾
      </button>
      {open && (
        <div className="absolute right-0 top-6 bg-white border border-stone-200 rounded-lg shadow-lg p-1 z-10 w-48 text-stone-800">
          {BLOCK_TYPES.map((t: BlockType) => (
            <button
              key={t}
              type="button"
              className="w-full text-left px-2 py-1.5 text-sm text-stone-800 hover:bg-stone-100 rounded flex items-center gap-2"
              onClick={() => { onAdd(makeBlock(t)); setOpen(false); }}
            >
              <span>{BLOCK_LABELS[t].icon}</span>
              <span>{BLOCK_LABELS[t].label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
